import React, {FC} from 'react';
import styled from 'styled-components';

export interface GraphicRadioButtonRowProps {
  children?: React.ReactNode;
}

export const GraphicRadioButtonRow: FC<GraphicRadioButtonRowProps> = ({
  children,
}) => {
  const parentScrollToRef = React.useRef<HTMLDivElement>(null);

  const renderChildren = (
    parentScrollToRef: React.RefObject<HTMLDivElement>
  ) => {
    return React.Children.map(children as React.ReactElement, (child) => {
      return React.cloneElement(child, {
        parentScrollToRef,
      });
    });
  };

  return (
    <GraphicRadioButtonRowWrapper ref={parentScrollToRef}>
      {renderChildren(parentScrollToRef)}
    </GraphicRadioButtonRowWrapper>
  );
};

export const GraphicRadioButtonRowWrapper = styled.div<{
  ref: React.RefObject<HTMLDivElement>;
}>`
  display: flex;
  width: auto;
  margin: ${({theme}) =>
    ` -4px calc(${theme.brand.spacing.inputSectionLayout?.inlineStart} * -1)`};
  padding: 6px
    ${({theme}) => theme.brand.spacing.inputSectionLayout?.inlineStart};
  overflow-x: scroll;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${({theme}) => theme.internal.Breakpoints.b560}px) {
    gap: ${({theme}) => theme.internal.size.static150};
    margin: 0;
    padding: 0;
    overflow: visible;
  }
`;
